import { useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { signOut } from "../../lib/auth.js";
import { useSession } from "../../lib/useSession.js";
import { DEMO_LP } from "../../data/portalDemo.js";

export default function PortalLayout() {
  const session = useSession();
  const nav = useNavigate();
  const [entityIdx, setEntityIdx] = useState(0);
  const [entityOpen, setEntityOpen] = useState(false);

  // While loading auth, show a slim skeleton so the shell doesn't flash.
  if (session === undefined) {
    return <div className="portal-bootstrap">Loading portal…</div>;
  }
  if (!session) {
    nav("/login", { replace: true });
    return null;
  }

  async function handleSignOut() {
    await signOut();
    nav("/login");
  }

  const entity = DEMO_LP.entities[entityIdx] || DEMO_LP.entities[0];
  const email = session.email || DEMO_LP.email;

  return (
    <div className="portal-shell">
      {/* TOP BAR */}
      <header className="portal-topbar">
        <div className="portal-topbar-left">
          <Link to="/" className="portal-logo">
            <img src="/df-logo.png" alt="Daksfirst" />
            <span>Daksfirst</span>
          </Link>
          <span className="portal-divider">|</span>
          <span className="portal-entity-name">{entity.name}</span>
        </div>
        <div className="portal-topbar-right">
          {session?.demo && (
            <span className="portal-demo-pill" title="No real backend session — using local demo data. Sign in via magic-link to use the live database.">
              Demo mode
            </span>
          )}
          <span className="portal-user">{email}</span>
          <button className="portal-signout" onClick={handleSignOut}>Sign out</button>
        </div>
      </header>

      {/* MAIN — sidebar + content */}
      <div className="portal-body">
        <aside className="portal-rail">
          <nav>
            <NavLink to="/portal"           end className={({isActive}) => "rail-link" + (isActive ? " active" : "")}>
              <span className="rail-dot"/> Dashboard
            </NavLink>
            <NavLink to="/portal/pipeline"  className={({isActive}) => "rail-link" + (isActive ? " active" : "")}>
              <span className="rail-dot"/> Live deals
            </NavLink>
            <NavLink to="/portal/documents" className={({isActive}) => "rail-link" + (isActive ? " active" : "")}>
              <span className="rail-dot"/> Documents
            </NavLink>
            <div className="rail-group">Onboarding</div>
            <NavLink to="/portal/onboarding/kyc"     className={({isActive}) => "rail-sublink" + (isActive ? " active" : "")}>
              KYC submission
            </NavLink>
            <NavLink to="/portal/onboarding/status"  className={({isActive}) => "rail-sublink" + (isActive ? " active" : "")}>
              KYC status
            </NavLink>
            <div className="rail-group">Account</div>
            <NavLink to="/portal/account"   className={({isActive}) => "rail-sublink" + (isActive ? " active" : "")}>
              Profile &amp; preferences
            </NavLink>
            <NavLink to="/portal/account/passkeys" className={({isActive}) => "rail-sublink" + (isActive ? " active" : "")}>
              Passkeys &amp; security
            </NavLink>
          </nav>
          <div className="rail-foot">
            <div className="rail-foot-line">Wealth via</div>
            <div className="rail-foot-strong">Maystone Capital Limited</div>
            <div className="rail-foot-fine">FCA FRN 758412</div>
          </div>
        </aside>

        <main className="portal-main">
          <div className="portal-entity-bar">
            <span>{entity.name}</span>
            {DEMO_LP.entities.length > 1 && (
              <span className="entity-switch" onClick={() => setEntityOpen(o => !o)}>
                Choose Entity ▾
                {entityOpen && (
                  <div className="entity-menu">
                    {DEMO_LP.entities.map((e, i) => (
                      <div key={e.id}
                           className={"entity-item" + (i === entityIdx ? " active" : "")}
                           onClick={(ev) => { ev.stopPropagation(); setEntityIdx(i); setEntityOpen(false); }}>
                        {e.name}
                      </div>
                    ))}
                  </div>
                )}
              </span>
            )}
          </div>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
